module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title17"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title17"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781439617960_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781439617960_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_dedicationPage",
    attrs: {
      "href": "#/e9781439617960_ded01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Dedication")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781439617960_ack01"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781439617960_fm02"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTRODUCTION")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c01"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CANADIAN AMERICAN HOCKEY LEAGUE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("2")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE EARLY AHL YEARS AND TWO CALDER CUPS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("3")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE GOLDEN AGE OF HOCKEY AND ANOTHER CHAMPIONSHIP")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("AN AFFILIATION WITH THE RANGERS BRINGS A FOURTH AHL TITLE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("TH E BOSTONBRUINS REESTABLISH PROVIDENCE AS ITS FARM TEAM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE REDS’ LATER AHL SEASONS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("7")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("PROFESSIONAL HOCKEY RETURNS TO PROVIDENCE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("8")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE P - BRUINS CAPTURE THE CALDER CUP")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("9")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("PROVIDENCE CONTINUES TO DEVELOP BOSTON TALENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439617960_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("10")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("HONORED MEMBERS OF THE HOCKEY HALLS OF FAME")])])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13d8d31e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439617960_toc01.vue
// module id = 69
// module chunks = 0